import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from 'reactstrap';
import StorageService from '../services/StorageService';
import axios from 'axios';
import { MdDone, MdClear, MdCreate } from 'react-icons/md';

class AssignUserForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      user: '',
      role: '',
      userList: [],
      roleList: [],
      compUserList: [],
      filterUserList: [],
    };
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();

    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const data = {
      session_key: user.session_key,
      CompanyID: this.props.match.params.id,
      ProfileID: this.state.user,
      Role: this.state.role,
    };

    axios
      .post(url + ':3000/v1/company/addUser', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'User assigned successfully.',
          'success',
          true,
        );
      })
      .catch(error => {
        alert(error);
      });
  };

  getRoleList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
    };

    axios
      .post(url + ':3000/v1/user/roles', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ roleList: result.data });
      })
      .catch(error => {
        alert(error);
      });
  };

  filterUserList = () => {
    let allUser = this.state.userList;
    let compUser = this.state.compUserList;

    let r = allUser.filter(function (a) {
      return !compUser.some(function (b) {
        return a.ProfileID === b.ProfileID; // assumes unique id
      });
    });

    this.setState({
      filterUserList: r,
    });
  };

  getCompanyUser = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
      CompanyID: this.props.match.params.id,
    };

    axios
      .post(url + ':3000/v1/company/getUser', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ compUserList: result.data });
        setTimeout(() => {
          this.filterUserList();
        }, 500);
      })
      .catch(error => {
        alert(error);
      });
  };

  getUserList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
    };

    axios
      .post(url + ':3000/v1/user/get', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ userList: result.data });
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    this.getUserList();
    this.getCompanyUser();
    this.getRoleList();
  }

  render() {
    const user = StorageService.getSession('user_info');
    return (
      <Form onSubmit={this.handleSubmit} className="AuthForm">
        <ModalHeader toggle={this.props.onToggleModal()}>
          Assign User
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="user">User</Label>
                <Input
                  type="select"
                  name="user"
                  value={this.state.user}
                  onChange={this.changeHandler}
                  required
                >
                  <option value=""></option>
                  {this.state.filterUserList.length > 0 &&
                    this.state.filterUserList.map((item, index) => {
                      return (
                        <option key={index} value={item.ProfileID}>
                          {item.Email} |{' '}
                          {item.Name === null || item.Name === ''
                            ? 'Nil'
                            : item.Name}
                        </option>
                      );
                    })}
                </Input>
              </FormGroup>
              <FormGroup>
                <Label for="role">Role</Label>
                <Input
                  type="select"
                  name="role"
                  value={this.state.role}
                  onChange={this.changeHandler}
                  required
                >
                  <option key="99" value=""></option>
                  {this.state.roleList.length > 0 &&
                    this.state.roleList.map((item, index) => {
                      return (
                        <option key={index} value={item.role}>
                          {item.role}
                        </option>
                      );
                    })}
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>{' '}
        </ModalFooter>
      </Form>
    );
  }
}

export default AssignUserForm;
